@import "../use-bootstrap-mixins";

.main {
  max-width: 500px;
  margin: 20vw auto;
  text-align: center;

  svg {
    path {
      fill: $primary;
    }
  }

  button {
    width: 50%;
  }
}
